<mat-toolbar>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    horizontal
    fxLayoutAlign.gt-xs="space-between center"
    fxFlex
  >
    <button
      (click)="back()"
      class="bg-danger"
      mat-fab
      aria-label="Example icon button with a delete icon"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div fxLayout="row" fxLayoutAlign="center center" fxShow.gt-xs>
      <!-- <a mat-button class="s-16 mr-sm-4" routerLink="/documentation/getting-started/introduction" >Documentation</a>
            <span>&bull;</span>
            <a mat-button routerLink="/documentation/changelog">Changelog</a> -->
      <span class="copyright"
        >2019 - 2024 ஆக்கமும் பராமரிப்பும் நாம் தமிழர் கட்சி</span
      >
    </div>
    <span class="copyright">
      <button
        (click)="openChangeLog()"
        mat-button
        class="hide-for-welcome-alerts"
      >
        பதிப்புகள்
      </button>
    </span>
  </div>
</mat-toolbar>
